import { z } from "zod";

export const DashboardBase = z.object({
  openJobs: z.number(),
  recommendedJobs: z.number().optional(),
  savedJobs: z.number().optional(),
});

export type DashboardBase = z.infer<typeof DashboardBase>;

export const DashboardCountDto = z.object({
  count: z.number(),
});

export type DashboardCountDto = z.infer<typeof DashboardCountDto>;
